import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Send, Check } from "lucide-react";

const ContactPage = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setSent(true);
    setForm({ name: "", email: "", message: "" });
  };

  const inputStyle = {
    background: "var(--cp-bg)",
    borderColor: "var(--cp-border)",
    color: "#ffffff",
  };

  return (
    <div className="mx-auto max-w-2xl px-5 py-16">
      <div className="cp-fade-up flex items-center gap-3">
        <div
          className="flex h-10 w-10 items-center justify-center rounded-lg"
          style={{ background: "rgba(34,224,107,0.12)", color: "var(--cp-green)" }}
        >
          <Mail size={20} />
        </div>
        <h1 className="text-3xl font-bold sm:text-4xl" style={{ color: "#ffffff" }}>
          Contact
        </h1>
      </div>
      <p
        className="cp-fade-up mt-4 text-sm leading-relaxed sm:text-base"
        style={{ color: "var(--cp-muted)", animationDelay: "60ms" }}
      >
        Questions, corrections or partnership enquiries? Send us a message and we
        will get back to you.
      </p>

      {sent ? (
        <div
          className="cp-fade-up mt-8 flex items-center gap-3 rounded-2xl border p-6"
          style={{ borderColor: "rgba(34,224,107,0.25)", background: "rgba(34,224,107,0.05)" }}
        >
          <Check size={20} style={{ color: "var(--cp-green)" }} />
          <p className="text-sm" style={{ color: "#ffffff" }}>
            Thanks — your message has been sent. We will be in touch shortly.
          </p>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          className="cp-fade-up mt-8 flex flex-col gap-4"
          style={{ animationDelay: "120ms" }}
        >
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide" style={{ color: "var(--cp-muted)" }}>
              Name
            </label>
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              className="w-full rounded-lg border px-4 py-3 text-sm outline-none transition-colors focus:border-[var(--cp-green)]"
              style={inputStyle}
              placeholder="Your name"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide" style={{ color: "var(--cp-muted)" }}>
              Email
            </label>
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              required
              className="w-full rounded-lg border px-4 py-3 text-sm outline-none transition-colors focus:border-[var(--cp-green)]"
              style={inputStyle}
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide" style={{ color: "var(--cp-muted)" }}>
              Message
            </label>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              required
              rows={5}
              className="w-full resize-none rounded-lg border px-4 py-3 text-sm outline-none transition-colors focus:border-[var(--cp-green)]"
              style={inputStyle}
              placeholder="How can we help?"
            />
          </div>
          <button
            type="submit"
            className="cp-play-btn inline-flex items-center justify-center gap-2 rounded-lg px-6 py-3 text-sm font-bold transition-all"
          >
            Send Message
            <Send size={15} />
          </button>
        </form>
      )}

      <Link
        to="/"
        className="mt-8 inline-block text-sm font-semibold"
        style={{ color: "var(--cp-green)" }}
      >
        ← Back to Top Picks
      </Link>
    </div>
  );
};

export default ContactPage;
